import {
    Edit,
    required,
    TextInput,
    BooleanInput,
    Link,
    SimpleForm,
    TabbedShowLayout,
    Tab,
    useNotify,
    useDataProvider,
    FunctionField,
    useRefresh
} from "react-admin";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {EBooleanStatuses, EBooleanStatusesNumber} from "../../../Const/Enums";
import {useParams} from "react-router-dom";
import DailyInspirationLocalization from "./dailyInspirationLocalization";
import {useDispatch} from "react-redux";
import setLoadStatus from "../../../Store/LoaderReducer";
import {Calendar} from "react-multi-date-picker";
import {convertedDate, convertedDateWithTime} from "../../../Functions/ConvertedDate";

export const EditDailyInspiration = () => {
    const {id} = useParams();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const dispatch = useDispatch();

    const onDateChange = (e) => {
        if (e && e.value.unix) {
            const date = new Date(e.value.unix * 1000);
            formData.show_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        }
    }

    const initialRef = useRef(true);
    const [formData] = useState({
        name: '',
        show_date: '',
        published: true,
        subscription: true
    });

    useEffect(() => {
        if (!initialRef.current) {
            return;
        }
        initialRef.current = false;
    }, []);

    const editCreate = () => {
        if (!formData.name.length) {
            if (!formData.name.length) {
                document.querySelector('.name').classList.add('error');
            }

            return;
        }

        dispatch(setLoadStatus(true));

        dataProvider.update(`daily-inspirations/general`, {id: `${id}`, data: {
                name: formData.name,
                show_date: formData.show_date || document.getElementById('show_date').value,
                published: formData.published ? EBooleanStatusesNumber.True : EBooleanStatusesNumber.False,
                subscription: formData.subscription ? EBooleanStatusesNumber.True : EBooleanStatusesNumber.False
            }}).then(() => {
            dispatch(setLoadStatus(false));
            notify(`Daily Inspiration update`);
            refresh(true);
        }).catch((err) => {
            notify(err.message, {type: 'error'});
            dispatch(setLoadStatus(false));
        });
    };

    const Save = () => {
        return (
            <div className="dailyActionToolbar">
                    <Link to="/daily-inspirations/general" className="button bar-purple-button">Cancel</Link>
                <button
                    onClick={editCreate}
                    className="button bar-gradient-button"
                    type="button"
                >
                    <span>Save</span>
                </button>
            </div>
        );
    }

    const nameChange = (e) => {
        if (document.querySelector('.name').classList.contains('error')) {
            document.querySelector('.name').classList.remove('error');
        }
        formData.name = e.target.value;
    }

    return (
        <>
            <h2 className="dailyTitle">Edit Daily Inspiration</h2>
            <Edit title="Daily Inspiration">
                <TabbedShowLayout className="tabbedForm">
                    <Tab label="General">
                        <SimpleForm toolbar={<></>}>
                            <div className="tabbedFormWrap">
                                <FunctionField label="" render={(record) => {
                                    formData.name = record.name;
                                    return <>
                                        <TextInput className="formFields name" label="Name" name="name"
                                                   source="formData.name" fullWidth id="name" validate={required()}
                                                   onChange={(e) => {
                                                       nameChange(e)
                                                   }} multiline/>
                                        <p className="required-text">Required</p>
                                    </>;
                                }}/>
                                <span className="showDateLabel">Show Date</span>
                                <FunctionField source="show_date" render={(record) => {
                                    return (
                                        <>
                                            <Calendar
                                                value={record.show_date ? convertedDateWithTime(record.show_date) : null}
                                                onPropsChange={(e) => {
                                                    onDateChange(e)
                                                }}
                                                minDate="2000/01/01"
                                                maxDate="3000/12/31"
                                            />
                                            <input type="hidden" id="show_date"
                                                   value={record.show_date && !formData.show_date ? convertedDate(record.show_date) : formData.show_date}/>
                                        </>
                                    );
                                }}/>
                                <FunctionField label="" render={(record) => {
                                    formData.published = record.published;
                                    return <BooleanInput label="Visible"
                                                         name="published"
                                                         source="published"
                                                         className="booleanInput"
                                                         format={(value) => (value ? EBooleanStatuses.True : EBooleanStatuses.False)}
                                                         parse={(value) => (value ? EBooleanStatusesNumber.True : EBooleanStatusesNumber.False)}
                                                         onChange={(e) => {
                                                             formData.published = e.target.checked
                                                         }}/>;
                                }}/>
                                <FunctionField label="" render={(record) => {
                                    formData.subscription = record.subscription;
                                    return <BooleanInput label="Subscription Required"
                                                         name="subscription" source="subscription"
                                                         className="booleanInput"
                                                         format={(value) => (value ? EBooleanStatuses.True : EBooleanStatuses.False)}
                                                         parse={(value) => (value ? EBooleanStatusesNumber.True : EBooleanStatusesNumber.False)}
                                                         onChange={(e) => {
                                                             formData.subscription = e.target.checked
                                                         }}/>;
                                }}/>
                            </div>
                            <Save />
                        </SimpleForm>
                    </Tab>
                    <Tab label="EN" path="en">
                        <DailyInspirationLocalization />
                    </Tab>
                    <Tab label="PT" path="pt">
                        <DailyInspirationLocalization />
                    </Tab>
                    <Tab label="DE" path="de">
                        <DailyInspirationLocalization />
                    </Tab>
                </TabbedShowLayout>
            </Edit>
        </>
    );
}